import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'

import format from 'date-fns/format'

import { AppContext } from '../../App'
import Loader from '../../components-utils/Loader'
import DateRange, { FORMATDATE } from '../../components-utils/DateRange'

import {
  getProductUnavailabilities,
  saveProductUnavailabilities
} from '../../services/api'

import { loadItem } from '../../services/utils'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'

import './Unavailability.css'

class Unavailability extends Component {
  state = {}

  async componentDidMount() {
    const result = await loadItem(this.props, getProductUnavailabilities)
    if (result !== undefined) {
      this.setState({
        product: result.item,
        merchantCode: result.merchantCode
      })
    }
  }

  changeDate = (name, index, newDate) => {
    this.setState(state => ({
      product: {
        ...state.product,
        unavailabilities: state.product.unavailabilities.map(
          (unavailability, i) =>
            i === index
              ? {
                  ...unavailability,
                  [name]: format(newDate, FORMATDATE)
                }
              : unavailability
        )
      }
    }))
  }

  saveProductUnavailabilities = () => {
    const { product, merchantCode } = this.state

    const {
      snackbar,
      history,
      match: {
        params: { id }
      }
    } = this.props
    if (merchantCode !== undefined) {
      saveProductUnavailabilities(id, merchantCode, product)
        .then(period => {
          this.setState({ period }, () => {
            history.push(`/unavailabilities/${period.id}`)
            snackbar('Informations enregistrées')
          })
        })
        .catch(e => {
          console.log(e)
          snackbar(
            'Erreur pendant la sauvegarde de la catégorie. Veuillez réessayer',
            'error'
          )
        })
    }
  }

  addRange = newRange => {
    this.setState(state => ({
      product: {
        ...state.product,
        unavailabilities: [...state.product.unavailabilities, newRange]
      }
    }))
  }

  deleteRange = index => {
    this.setState(state => ({
      product: {
        ...state.product,
        unavailabilities: state.product.unavailabilities.filter(
          (range, i) => i !== index
        )
      }
    }))
  }

  renderLoader() {
    return <Loader loading={true} />
  }

  renderDates() {
    const {
      product: { id, unavailabilities }
    } = this.state
    return (
      <DateRange
        ranges={unavailabilities}
        changeDate={this.changeDate}
        addRange={this.addRange}
        deleteRange={this.deleteRange}
        nameId="productId"
        elementId={id}
      />
    )
  }

  render() {
    const { product } = this.state
    return product !== undefined ? (
      <Card key="page">
        <CardContent>
          <Typography variant="h4" className="sp-unavailability--subtitle">
            Indisponibilités - {product.value.technicalLabel}
          </Typography>
          {this.renderDates()}
        </CardContent>
        <CardActions className="sp-unavailability--actions">
          <Button
            variant="contained"
            color="secondary"
            onClick={this.saveProductUnavailabilities}
          >
            Valider
          </Button>
        </CardActions>
      </Card>
    ) : (
      this.renderLoader()
    )
  }
}

const enhanced = WrappedComponent => props => {
  return (
    <AppContext.Consumer>
      {app => <WrappedComponent {...props} snackbar={app.snackbar.open} />}
    </AppContext.Consumer>
  )
}

export default withRouter(enhanced(Unavailability))



// WEBPACK FOOTER //
// ./src/components/unavailabilities/Unavailability.js